import { render, staticRenderFns } from "./Pool.vue?vue&type=template&id=511b0392&"
import script from "./Pool.vue?vue&type=script&lang=ts&"
export * from "./Pool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports